<script>
let uuid = 0;
import { mapGetters, mapActions, mapState } from "vuex";
export default {
  beforeCreate() {
    this.uuid = uuid.toString();
    uuid += 1;
  },
  data: function() {
    return {
      model: null,
      isValid: null,
      errorMessages: []
    };
  },
  mounted() {
    this.model = this.value;
  },
  watch: {
    model: function(value) {
      this.value = value;
    },
    isValid: function(value) {
      this.updateFieldValidationStatus({
        blockId: this.block.id,
        value: value
      });
    },
    orderForm: function() {
      this.errorMessages = this.fieldError(this.block.id);
    },
  },
  props: {
    block: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters("orderForm", [
      "fieldValue",
      "fieldValidationStatus",
      "fieldError"
    ]),
    ...mapState("orderForm", ["blocks"]),
    field: function() {
      return this.block.fieldObject;
    },
    value: {
      get: function() {
        return this.fieldValue(this.block.id);
      },
      set: function(value) {
        this.updateField({ blockId: this.block.id, value: value }).then(() => {
          this.errorMessages = this.fieldError(this.block.id);
        });
      }
    },
    classField: function() {
      let c = "";
      if (!this.isValid) {
        c = "hasError";
      }
      return c;
    },
  },

  methods: {
    ...mapActions("orderForm", [
      "updateField",
      "saveField",
      "updateFieldValidationStatus",
      "addError"
    ]),
    update() {
      this.saveField({ blockId: this.block.id, value: this.model });
    },
    validate() {}
  }
};
</script>

<style lang="less">
.errorMsg{
  background-color: transparent !important;
  color:#bd1b1b !important;
  font-size: 12px;
}
</style>